// socket功能
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import utils from '@/util/index'
import {
  WS_URL
} from './constants'
let stompClient = null

//链接SockJS
export function connect(mp, id, fn) {
  let socket = new SockJS(WS_URL);
  // 获取STOMP子协议的客户端对象 
  stompClient = Stomp.over(socket);

  // 定义客户端的认证信息,按需求配置
  let headers = {
    // Authorization: ,
    cloudClass: JSON.stringify(mp)
  };

  // 拦截输出的一大堆垃圾信息
  stompClient.debug = function (str) {
    // console.log(str);
  };

  // 向服务器发起websocket连接
  stompClient.connect(headers, () => {
    // console.log('WS连接成功')
    // 订阅服务端提供的某个topic 
    stompClient.subscribe(`/websocket/topic/anyone/${id}`, (response) => {
      // console.log("connect -> response", response)
      fn(response)
    })
  }, (err) => {
    // console.log("connect -> err", err)
    // 连接发生错误时的处理函数
    console.log('WS链接失败')
  })
}


//断开链接
export function disconnect(mp) {
  if (stompClient != null) {
    //断开链接时会调用一个函数
    stompClient.disconnect(() => {
      // console.log('WS链接断开了');
    }, {
      cloudClass: JSON.stringify(mp)
    })
  } else {
    // console.log('WS未链接');
  }
}

//发送
export function send(data) {
  //发送
  let mp = {
    'Content-Type': 'application/json;charset=UTF-8',
    'token': utils.getSess('loginMessage'),
    'Authorazition': utils.getSess('Authorazition')
  }
  stompClient.send("/websocket/show/hello", {
    token: JSON.stringify(mp)
  }, JSON.stringify(data));
}